<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="primary--text pb-2">Advanced</h2>
      <p>Define an advanced query for your bucket.</p>
    </v-flex>
    <v-flex id="bucketadvanced-main">
      <v-flex>
        <v-textarea
          @keyup="$emit('bucket-update')"
          box
          id="bucketadvanced-desc-text"
          label="Advanced Filters - Advanced query for bucket"
          v-model="bucket.advancedQuery">
        </v-textarea>
      </v-flex>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    bucket: {
      type: Object,
      required: true
    }
  }
}
</script>
